<script setup lang="ts">
import BaseInput from '@/components/common/input/BaseInput.vue';
import {useField} from 'vee-validate';
import {ref} from 'vue';
import {toRef, watch} from 'vue';

// props, context, emits, libs
const props = defineProps({
    type: {
        type: String,
        default: 'text',
    },
    label: {
        type: String,
        default: '',
    },
    value: {
        type: [String, Number],
        default: '',
    },
    name: {
        type: String,
        required: true,
    },
    placeholder: {
        type: String,
        default: '',
    },
});

// ref, reactive
const localType = ref(props.type);
const name = toRef(props, 'name');
const value = toRef(props, 'value');
const {
    value: inputValue,
    errorMessage,
    handleChange,
    handleBlur,
    setValue,
} = useField(name, undefined, {
    initialValue: value,
});

const toggleShowPassword = () => {
    localType.value = localType.value === 'password' ? 'text' : 'password';
};

// effect (created, mounted, watch, VueUse)
watch([value], () => {
    setValue(value.value);
});
</script>

<template>
    <div class="vee">
        <label v-if="props.label" class="vee__label" :for="name">{{
            props.label
        }}</label>
        <div class="vee__input">
            <BaseInput
                v-bind="$attrs"
                :type="localType"
                :placeholder="props.placeholder"
                :model-value="inputValue"
                :name="name"
                :hasError="!!errorMessage"
                :hasShowPasswordIcon="props.type === 'password'"
                @input="handleChange"
                @blur="handleBlur"
                @show-password="toggleShowPassword"
            />
        </div>
    </div>
</template>
<style lang="scss" scoped>
.vee {
    display: flex;

    &__label {
        width: 83px;
        margin: 7px 16px 0 0;
    }

    &__input {
        flex: 1;
        height: 58px;
    }
}
</style>
